import { render, staticRenderFns } from "./ren-radio-group.vue?vue&type=template&id=31d96d68&"
import script from "./ren-radio-group.vue?vue&type=script&lang=js&"
export * from "./ren-radio-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports